<template>
	<div>
		<div class="vx-row">
			<div class="vx-col md:w-1/2 w-full mb-base">
				<vx-card title="Planes">
					<vue-apex-charts type="donut" height="300" :options="donutChart.chartOptions" :series="donutChart.series"></vue-apex-charts>
				</vx-card>
			</div>
			<div class="vx-col md:w-1/2 w-full mb-base">
				<vx-card title="Estado">
					<vue-apex-charts type="pie" height="300" :options="pieChart.chartOptions" :series="pieChart.series"></vue-apex-charts>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col md:w-1/2 w-full mb-base">
				<vx-card title="Mensajes">
					<vue-apex-charts type="radialBar" height="300" :options="radialBarChart.chartOptions" :series="radialBarChart.series"></vue-apex-charts>
				</vx-card>
			</div>
			<div class="vx-col md:w-1/2 w-full mb-base">
				<vx-card title="Radar">
					<vue-apex-charts type="radar" height="265" :options="radarChart.chartOptions" :series="radarChart.series"></vue-apex-charts>
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col md:w-1/2 w-full mb-base">
				<vx-card title="Indicadores">
					<vue-apex-charts type="bar" height="300" :options="barChart.chartOptions" :series="barChart.series"></vue-apex-charts>
				</vx-card>
			</div>
			<div class="vx-col md:w-1/2 w-full mb-base">
				<vx-card title="Planes">
					<vue-apex-charts type="area" height="300" :options="areaChart.chartOptions" :series="areaChart.series"></vue-apex-charts>
				</vx-card>
			</div>
		</div>
	</div>
</template>
	
	<script>
	import VueApexCharts from 'vue-apexcharts'
	import ChartjsComponentLineChart from './charts-components/ChartjsComponentLineChart.vue'
	import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
	import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
	import VxTimeline from '@/components/timeline/VxTimeline'
	import analyticsData from './analyticsData.js'
	import apexChatData from './apexChartData.js'
	const themeColors = ['#28C76F', '#EA5455', '#7367F0', '#FF9F43', '#1E1E1E']
	export default {
		components: {
			VueApexCharts,
			ChartjsComponentLineChart,
			StatisticsCardLine,
			ChangeTimeDurationDropdown,
			VxTimeline
		},
		data() {
			return {
				donutChart: {
					series: [0, 0, 0],
					chartOptions: {
						labels: ['Plan 1', 'Plan 2', 'Plan 3'],
						colors: themeColors,
						responsive: [{
							breakpoint: 480,
							options: {
								chart: {
									width: 200
								},
								legend: {
									position: 'bottom'
								}
							}
						}]
					}
				},
				barChart: {
					series: [{
						name: '',
						data: [0, 0, 0, 0, 0]
					}],
					chartOptions: {
						labels: ['Ya pague', 'No es mi deuda', 'No tengo plata', 'No estoy de acuerdo', 'Confirmar Acuerdo', 'Difícil Situación', 'Hablar con Asesor'],
						colors: themeColors,
						responsive: [{
							breakpoint: 480,
							options: {
								chart: {
									width: 200
								},
								legend: {
									position: 'bottom'
								}
							}
						}],
						scales: {
							y: {
								beginAtZero: true
							}
						},
					}
				},
				pieChart: {
					series: [0, 0],
					chartOptions: {
						labels: ['Aprobado', 'Rechazado'],
						colors: themeColors,
						responsive: [{
							breakpoint: 480,
							options: {
								chart: {
									width: 200
								},
								legend: {
									position: 'bottom'
								}
							}
						}]
					}
				},
				radarChart: {
					series: [{
						name: '',
						data: [0, 0, 0, 0, 0]
					}],
					chartOptions: {
						colors: themeColors,
						labels: ['No tengo plata', 'No es mi deuda', 'No me afecta', 'Ya pague', 'Hablar con un asesor', 'Firmar Convenio']
					}
				},
				radialBarChart: {
					series: [0, 0, 0],
					chartOptions: {
						colors: themeColors,
						plotOptions: {
							radialBar: {
								dataLabels: {
									name: {
										fontSize: '22px'
									},
									value: {
										fontSize: '16px'
									},
									total: {
										show: true,
										label: 'Total',
										formatter() {
											// By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
											return 0
										}
									}
								}
							}
						},
						labels: ['Enviados', 'Entregados', 'Recibidos']
					}
				},
				areaChart: {
					series: [{
						name: '',
						data: [0, 0, 0, 0, 0]
					}],
					chartOptions: {
						colors: themeColors
					}
				},
				apexChatData,
				analyticsData,
				productsOrder: {},
				salesRadar: {},
				lineChartSimple: {
					series: [{
						name: 'Plan',
						data: [0, 0, 0]
					}],
					chartOptions: {
						chart: {
							height: 350,
							zoom: {
								enabled: false
							}
						},
						colors: themeColors,
						dataLabels: {
							enabled: false
						},
						stroke: {
							curve: 'straight'
						},
						title: {
							text: 'Plan',
							align: 'left'
						},
						grid: {
							row: {
								colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
								opacity: 0.5
							}
						},
						xaxis: {
							categories: ['Plan 1', 'Plan 2', 'Plan 3']
						}
					}
				},
				lineChartSimpleD: {
					series: [{
						name: 'Estado',
						data: [0, 0]
					}],
					chartOptions: {
						chart: {
							height: 350,
							zoom: {
								enabled: false
							}
						},
						colors: themeColors,
						dataLabels: {
							enabled: false
						},
						stroke: {
							curve: 'straight'
						},
						title: {
							text: 'Plan',
							align: 'left'
						},
						grid: {
							row: {
								colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
								opacity: 0.5
							}
						},
						xaxis: {
							categories: ['Aprobado', 'Rechazado']
						}
					}
				},
				data: {
					labels: [0, 0, 0, 0],
					datasets: [{
						data: [0, 1, 1, 0],
						label: 'Plan 1',
						borderColor: '#7367F0',
						fill: false
					}, {
						data: [0, 1, 0, 0],
						label: 'Plan 2',
						borderColor: '#28C76F',
						fill: false
					}, {
						data: [0, 0, 0, 1],
						label: 'Plan 3',
						borderColor: '#EA5455',
						fill: false
					}]
				},
				options: {
					title: {
						display: true,
						text: ''
					}
				}
	
			}
		},
		mounted() {
			this.getLista();
		},
		methods: {
			getLista() {
				let idSheets = '1GWLWHz5WWz9rzAnHjdDw-LOWHjyFRGlemBlnQBwOHUI';
				let apiKey = 'AIzaSyC1TSEFts6DBpbKPbA-Qj3QExRNVtZIONM';
				let values = 'A2:AZ100';
				let plan_1 = 0
				let plan_2 = 0
				let plan_3 = 0
				let aprobado = 0
				let rechasado = 0
				let envidos = 0
				let entregados = 0
				let recibidos = 0
				let a = 0
				let b = 0
				let c = 0
				let d = 0
				let e = 0
				let f = 0
	
				fetch("https://content-sheets.googleapis.com/v4/spreadsheets/" + idSheets + "/values/A2:AZ300?access_token=" + apiKey + "&key=" + apiKey)
					.then((lista) => {
						return lista.json()
					}).then((valores) => {
						this.listaDatos = valores.values
						this.listaDatos.forEach(element => {
							if(element['22']){
								plan_1 += parseInt(element['22'])
								plan_2 += parseInt(element['23'])
								plan_3 += parseInt(element['24'])
								aprobado += parseInt(element['25'])
								rechasado += parseInt(element['26'])
								envidos += parseInt(element['27'])
								entregados += parseInt(element['28'])
								recibidos += parseInt(element['29'])
								a += parseInt(element['30'])
								b += parseInt(element['31'])
								c += parseInt(element['32'])
								d += parseInt(element['33'])
								e += parseInt(element['34'])
								f += parseInt(element['35'])
							}
						});
						this.donutChart.series = [plan_1,plan_2,plan_3]
						this.lineChartSimpleD.series = [{
							name: 'Estado',
							data: [aprobado,rechasado]
						}]
						this.pieChart.series = [aprobado,rechasado]
						this.radialBarChart.chartOptions = {
							colors: themeColors,
							plotOptions: {
								radialBar: {
									dataLabels: {
										name: {
											fontSize: '22px'
										},
										value: {
											fontSize: '16px'
										},
										total: {
											show: true,
											label: 'Total',
											formatter() {
												let tot = envidos + entregados + recibidos
												return tot
											}
										}
									}
								}
							},
							labels: ['Enviados', 'Entregados', 'Recibidos']
						}
						this.radialBarChart.series = [((envidos * 100)/(envidos+entregados+recibidos)), ((entregados * 100)/(envidos+entregados+recibidos)), ((recibidos * 100)/(envidos+entregados+recibidos))],
						this.barChart.series =[{ 
							name: '',
							data: [a, b, c, d, e, f]
						}],						
						this.radarChart.series = [{
							name: '',
							data: [((a*100)/(a+b+c+d+e)), ((b*100)/(a+b+c+d+e)), ((c*100)/(a+b+c+d+e)), ((d*100)/(a+b+c+d+e)), ((e*100)/(a+b+c+d+e))]
						}],
						this.areaChart.series = [{
							name: 'Plan 1',
							data: ['50', plan_1, '10']
						}, {
							name: 'Plan 2',
							data: [30, plan_2, 60]
						},{
							name: 'Plan 3',
							data: [100, plan_3, 143]
						}],
						console.log(this.listaDatos)
					}).catch(err => {
						console.log(err);
					})
			}
		}
	}
	</script>